import PropTypes from "prop-types";

export const FooterComponent = ({ isLoading, moreNotifications }) => {
  let text = "";
  let color = "";

  if (isLoading && moreNotifications) {
    text = "Loading more notifications...";
    color = "#555";
  } else if (!moreNotifications) {
    text = "No more notifications to show";
    color = "#888";
  }

  return text ? (
    <div
      style={{
        padding: "24px 0",
        textAlign: "center",
        color,
        fontSize: "13px",
      }}
    >
      {text}
    </div>
  ) : null;
};

FooterComponent.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    moreNotifications: PropTypes.bool.isRequired,
  };